import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type {
  BaseF5osApiSettingsDefaults,
  F5osAApiSettingsDefaults,
  F5osCApiSettingsDefaults,
} from './types';

const baseF5osDefaults: BaseF5osApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxConcurrentRequests: 100,
  maxCapacity: 100,
  refillRate: 100,
  refillRateIntervalMs: 1_000,
  keepAlive: true,
  keepAliveMs: 60_000,
  defaultSessionTimeoutSec: 0,
};

export const f5osADefaults: F5osAApiSettingsDefaults = {
  ...baseF5osDefaults,
};

export const f5osCDefaults: F5osCApiSettingsDefaults = {
  ...baseF5osDefaults,
};
